import { Button, DatePicker, Form, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "../styles/Content.module.css";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const data = [
    {
      name: 'am',
      value: 4000,
      anterior: 2400,
      amt: 2400,
    },
    {
      name: 'am',
      value: 3000,
      anterior: 1398,
      amt: 2210,
    },
    {
      name: 'am',
      value: 2000,
      anterior: 9800,
      amt: 2290,
    },
    {
      name: 'am',
      value: 2780,
      anterior: 3908,
      amt: 2000,
    },
    {
      name: 'pm',
      value: 1890,
      anterior: 4800,
      amt: 2181,
    },
    {
      name: 'pm',
      value: 2390,
      anterior: 3800,
      amt: 2500,
    },
    {
      name: 'pm',
      value: 3490,
      anterior: 4300,
      amt: 2100,
    },
  ];
  
const OrdersPerHour = ({branches, isAdmin, onFinishFilterDate, summaryHours}) => {
  return (
    <div className={styles.cardContent}>
      <div className={styles.filterForm} style={{ justifyContent: 'flex-end' }}>
        <Form layout="inline" onFinish={onFinishFilterDate}>
          {isAdmin && (
            <Form.Item name="location">
              <Select
                className={styles.select}
                showSearch
                optionFilterProp="label"
                options={branches.map((item) => {
                  return { value: item.id, label: item.zone };
                })}
                allowClear
                placeholder="Todas las sucursales"
              />
            </Form.Item>
          )}
          <Form.Item name="date">
            <DatePicker />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ display: 'inline-flex', alignItems: 'center' }}>
              Buscar
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className={styles.chartContainer}>
        <p className={styles.chartTitle}>Total Ventas</p>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip
              contentStyle={{ borderRadius: '8px', border: '1px solid #f0f0f0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#FF671D"
              strokeWidth={2}
              dot={{ r: 3, fill: '#FF671D' }}
              activeDot={{ r: 6, stroke: '#FF671D', strokeWidth: 2, fill: '#fff' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OrdersPerHour;
